import { NgRedux, select } from '@ptl/angular-redux-store';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlansStateStructure } from '../configs/interfaces/plansStateStructure.interface';
import { PRODUCT_GROUP_NAMES } from '../enums/product-groups.enum';
import { PlanAttributes, SummaryView } from '../interfaces/plan-attributes.interface';
import { Product } from '../interfaces/product.interface';
import { PlanUtilityService } from '../plan-summary-list/plan-utility.service';
import { setPaginationData, resetPageIndex } from './configs/plan-summary-list-paginator.reducer';
import { Observable } from 'rxjs';
import { PlanAttributeFilterPipe } from '../plan-filter/pipes/plan-filter.pipe';

@Component({
    selector: 'app-plan-summary-list-paginator',
    templateUrl: './plan-summary-list-paginator.component.html',
    styleUrls: ['./plan-summary-list-paginator.component.scss'],
    standalone: false
})
export class PlanSummaryListPaginatorComponent implements OnInit, AfterViewInit {

  @Input() private pageSizeOptions: string = '6, 12, 18, 30, 60';
  formattedPageSizeOptions: number[];
  pageSize: number = 60;
  totalLength: number;
  @select(['componentStates', 'Plans', 'plansByPlanType']) plansByPlanType$: Observable<string>;
  @select(['componentStates', 'PlanSummaryListPaginator', 'totalLength']) totalLength$: Observable<string>;
  @ViewChild('planSummaryListPaginator') paginator: MatPaginator;

  products: Map<PRODUCT_GROUP_NAMES, Product<PlanAttributes, SummaryView>[]>;
  activePlans: Product<PlanAttributes, SummaryView>[];

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private planUtilityService: PlanUtilityService,
    private reducerUtilityService: ReducerUtilityService,
    private planFilter: PlanAttributeFilterPipe
  ) { }

  ngOnInit(): void {

    this.formattedPageSizeOptions = (() => {
      try {
        const regex = new RegExp(/ /, 'g');
        const trimmed = this.pageSizeOptions.replace(regex, '');
        const split = trimmed.split(',');
        const array = split.map((pageSize: string) => parseInt(pageSize, 10));
        return array;
      } catch (e) {
        console.log('No valid paginator setting available, hiding (Hint: "1, 2, 10, 50")');
      }
    })();

    this.plansByPlanType$.subscribe(value => {
      this.getActiveProductGroupProducts();
    });

    this.totalLength$.subscribe(value => {
      this.totalLength = parseInt(value, 10);
    });
  }

  ngAfterViewInit(): void {
    const options = this.formattedPageSizeOptions;
    if (options) {
      const lastIndex = options.length - 1;
      this.ngRedux.dispatch(setPaginationData(0, options[lastIndex]));
      this.pageSize = options[lastIndex];
    }
  }

  private setProductsPlanMap(): Map<PRODUCT_GROUP_NAMES, Product<PlanAttributes, SummaryView>[]> {
    this.products = this.planUtilityService.getAllPlansAsMap();
    return this.products;
  }

  getActiveProductGroupProducts() {
    this.setProductsPlanMap();
    const activeProductGroup
      = (this.reducerUtilityService.getComponentStates()['Plans'] as PlansStateStructure).activeProductGroup;
    this.activePlans = this.products.get(activeProductGroup);
  }

  change(event: { length: number, pageIndex: number, pageSize: number, previousPageIndex: number }) {
    this.ngRedux.dispatch(setPaginationData(event.pageIndex, event.pageSize));
  }
}
